/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Stop limit order request
 */
export interface StopLimitOrderRequest {
  /**
   * Account ID.
   */
  accountId: number;
  /**
   * Trade direction.
   */
  side: StopLimitOrderRequest.SideEnum;
  /**
   * Qty for client(in base asset).
   */
  units: number;
  /**
   * Base pair ID.
   */
  basePairId: number;
  /**
   * Limit price.
   */
  limitPrice: number;
  /**
   * Stop(trigger) price.
   */
  stopPrice: number;
}
export namespace StopLimitOrderRequest {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
}
